import { useEffect, useState } from "react";
import { useEnhancedAnimations } from "@/hooks/useMotionPreferences";

export function CustomCursor() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [followerPosition, setFollowerPosition] = useState({ x: 0, y: 0 });
  const enhancedAnimationsEnabled = useEnhancedAnimations();

  useEffect(() => {
    if (!enhancedAnimationsEnabled) return;

    const handleMouseMove = (e: MouseEvent) => {
      // Main cursor follows immediately
      setPosition({ x: e.clientX, y: e.clientY });
      
      // Follower has slight delay (handled by CSS transition)
      requestAnimationFrame(() => {
        setFollowerPosition({ x: e.clientX, y: e.clientY });
      });
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [enhancedAnimationsEnabled]);

  // Don't render custom cursor if enhanced animations are disabled
  if (!enhancedAnimationsEnabled) {
    return null;
  }

  // Note: The marker div below triggers CSS :has(.custom-cursor-active) on body
  // to hide the default cursor only when custom cursor is rendered

  return (
    <>
      {/* Marker for CSS :has() selector to hide default cursor */}
      <div className="custom-cursor-active hidden" aria-hidden="true" />
      
      {/* Main cursor ring */}
      <div
        className="fixed w-5 h-5 border-2 border-[#00d9ff] rounded-full pointer-events-none z-[9999] -translate-x-1/2 -translate-y-1/2 transition-transform duration-200"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          boxShadow: "0 0 20px rgba(0, 217, 255, 0.6)",
        }}
        data-testid="custom-cursor-ring"
      />
      
      {/* Follower dot */}
      <div
        className="fixed w-2 h-2 bg-[#00d9ff] rounded-full pointer-events-none z-[9998] -translate-x-1/2 -translate-y-1/2 transition-all duration-150"
        style={{
          left: `${followerPosition.x}px`,
          top: `${followerPosition.y}px`,
          boxShadow: "0 0 10px rgba(0, 217, 255, 0.8)",
        }}
        data-testid="custom-cursor-dot"
      />
    </>
  );
}
